module.exports = __webpack_public_path__ + "img/72b4137.png";